/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsAlphabetCollection,
    MelcoModelsAlphabetCollectionFromJSON,
    MelcoModelsAlphabetCollectionFromJSONTyped,
    MelcoModelsAlphabetCollectionToJSON,
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoModelsAlphabetCollection
 */
export interface MelcoModelsGenericList1MelcoModelsAlphabetCollection {
    /**
     * 
     * @type {Array<MelcoModelsAlphabetCollection>}
     * @memberof MelcoModelsGenericList1MelcoModelsAlphabetCollection
     */
    list: Array<MelcoModelsAlphabetCollection>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoModelsAlphabetCollection
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoModelsAlphabetCollection
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoModelsAlphabetCollectionFromJSON(json: any): MelcoModelsGenericList1MelcoModelsAlphabetCollection {
    return MelcoModelsGenericList1MelcoModelsAlphabetCollectionFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoModelsAlphabetCollectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoModelsAlphabetCollection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoModelsAlphabetCollectionFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoModelsAlphabetCollectionToJSON(value?: MelcoModelsGenericList1MelcoModelsAlphabetCollection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoModelsAlphabetCollectionToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


